import React, { useEffect, useState } from "react";
import "./confirm.css";

import notvisited from "../../assets/icons/not-visited.png";
import notanswered from "../../assets/icons/not-answered.png";
import answered from "../../assets/icons/answered.png";
import notanswerreview from "../../assets/icons/not-answered-review.png";
import answerreview from "../../assets/icons/answered-review.png";

import Icon from "../../assets/icons/Icon.svg";
import { submitTestApi } from "../../services/saveAndNext";
import { connect } from "react-redux";
import api from "../../api";

const ConfirmOverall = (props) => {
  const { setShow } = props;
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (props?.test_data?.test_id && props?.student_data?.userid) {
      fetchTestInfo();
    }
  }, [props?.test_data?.test_id, props?.student_data?.userid]);

  function setSessionHeaders() {
    let sessionKey = "";
    let accountdata = props?.institute_data;
    let testdata = props?.test_data;
    let studentdata = props?.student_data;
    if (studentdata && testdata && accountdata) {
      sessionKey =
        studentdata.userid +
        ":" +
        testdata.test_id +
        ":" +
        accountdata.account_id +
        ":" +
        props.session_key;
      sessionKey = btoa(sessionKey);
      return sessionKey;
    }
  }

  const fetchTestInfo = async () => {
    const testId = props?.test_data?.test_id;
    const studentId = props?.student_data?.userid;
    if (!testId || !studentId) return;

    const request = {
      url: `/v1/examPanel/getTestInfo`,
      headers: {
        "x-device-key": localStorage.getItem("identityKey"),
        "x-session-key": setSessionHeaders(),
      },
      data: {
        test_id: testId,
        user_id: studentId,
      },
    };

    try {
      const response = await api.postAuthTZ(request);
      if (response?.data.subjects) {
        setSubjects(response.data.subjects);
      }
    } catch (err) {
      console.error("❌ Error fetching overall test info:", err);
    } finally {
      setLoading(false);
    }
  };

  const submitTest = (isMannualSubmit = 0) => {
    setShow(false);
    submitTestApi(props, isMannualSubmit);
  };

  return (
    <div className="popup-box">
      <div
        className="modal-body-md"
        style={{ width: "650px", maxHeight: "450px", overflowY: "auto" }}
      >
        <div className="headerv">
          <img src={Icon} alt="icon" />
          <h2>
            Are you sure you want to finish the test?
            <p>
              If you click SUBMIT, you will not be able to change your answers.
            </p>
          </h2>
        </div>

        {loading ? (
          <p style={{ padding: "20px", textAlign: "center" }}>Loading...</p>
        ) : (
          <div className="tt-10">
            {subjects.map((s, i) => (
              <div
                key={i}
                style={{
                  borderBottom: "1px solid #eee",
                  padding: "12px 10px 10px 6px",
                  marginBottom: "8px",
                }}
              >
                <strong>
                  {s.subject_name} - {s.section_title}
                </strong>

                {/* Two-column layout */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    marginLeft: "20px",
                    marginTop: "5px",
                    marginBottom:"10px",
                    fontSize: "14px",
                  }}
                >
                  {/* Left column (3 stats) */}
                  <div style={{ flex: 1 }}>
                  <div style={{ marginBottom: "6px" }}>
                      <img src={notvisited} alt="not visited" /> Not Visited:{" "}
                      {s.not_visited_count}
                    </div>
                    <div style={{ marginBottom: "6px" }}>
                      <img src={notanswered} alt="not answered" /> Not Answered:{" "}
                      {s.unanswer_count}
                    </div>
                    <div style={{ marginBottom: "6px" }}>
                      <img src={answered} alt="answered" /> Answered:{" "}
                      {s.answer_count}
                    </div>
                  </div>

                  {/* Right column (2 stats) */}
                  <div style={{ flex: 1 }}>
                  <div style={{ marginBottom: "6px" }}>
                      <img src={notanswerreview} alt="review" /> Marked for
                      Review: {s.review_count}
                    </div>
                    <div style={{ marginBottom: "6px" }}>
                      <img src={answerreview} alt="answered review" /> Answered &
                      Marked: {s.mark_answer_count}
                    </div>
                  </div>
                </div>
                <div style={{
                    
                    marginLeft: "20px",
                    
                  }}>
                                    <strong>
Total: {s.total_questions}
</strong></div>


                {/* Total below */}
               
              </div>
            ))}
          </div>
        )}

        <div className="display">
          <button onClick={() => setShow(false)}>CANCEL</button>
          {(props.is_test_submit_status=== 1 ) ? (
            <button onClick={() => submitTest(1)}>SUBMIT</button>
          ) : (
            <div>
              <button disabled>SUBMIT</button>
              <p style={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                You cannot submit test before end time!
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  test_data: state.test_data,
  student_data: state.student_data,
  institute_data: state.institute_data,
  session_key: state.session_key,
  is_test_submit_status: state.test_settings?.is_test_submit_status,
});
export default connect(mapStateToProps)(ConfirmOverall);
